import {put, takeLatest, call} from 'redux-saga/effects';
import * as reportService from "../../../services/reportService";
import {
    GET_DAILY_REPORT,
    GET_DAILY_REPORT_SUCCESS,
    GET_DAILY_REPORT_ERROR,
}
    from "../../actions/report"

function* getDailyReportSaga(action) {
    try {
       const data  = yield call(reportService.GetDailyReport,action.payload)
       yield put({
        type: GET_DAILY_REPORT_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_DAILY_REPORT_ERROR,error: error.data
        })
    }
}


export function* getDailyReportSagaWatcher() {
    yield takeLatest(GET_DAILY_REPORT, getDailyReportSaga)
}